import { SpeciesTaxonomyScreen } from '@/screens/SpeciesSearch/SpeciesTaxonomyScreen/SpeciesTaxonomyScreen';

export default function EditReportSpeciesTaxonomyScreen(): React.ReactNode {
  return <SpeciesTaxonomyScreen />;
}
